exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p {\n  margin-top: 20px;\n  line-height: 1.5em; }\n\nli {\n  line-height: 2em;\n  list-style: disc;\n  margin-top: 10px; }\n\nh5 {\n  font-weight: bolder; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/policy/policy.component.scss
// module id = ../../../../../src/app/pages/policy/policy.component.scss
// module chunks = main